import {GetConfigResponse} from "api/configs";
import {AxiosResponse} from "axios";
import {InitLoggerValues} from "./types";
import {DEFAULT_INIT_LOGGER_VALUES} from "./consts";

export const getValuesForInitLogger = (result?: AxiosResponse<GetConfigResponse, any>): InitLoggerValues => {
    const version = result?.data?.version;
    const appData = result?.data?.appData;

    if (!appData) {
        return DEFAULT_INIT_LOGGER_VALUES;
    }

    const {env, user, configs} = appData;

    return {
        env: env === 'unstable' ? 'development' : env || DEFAULT_INIT_LOGGER_VALUES.env,
        login: user?.login || DEFAULT_INIT_LOGGER_VALUES.login,
        version: version || DEFAULT_INIT_LOGGER_VALUES.version,
        configs: configs || DEFAULT_INIT_LOGGER_VALUES.configs,
    };
};
